export const CREATE_ASSET = "CREATE_ASSET";
export const FETCH_ASSETS = "FETCH_ASSETS";
export const FETCH_ASSET = "FETCH_ASSET";
export const EDIT_ASSET = "EDIT_ASSET";
export const DELETE_ASSET = "DELETE_ASSET";
